import { render, staticRenderFns } from "./GladlyWidget.vue?vue&type=template&id=21779174&scoped=true&lang=pug"
import script from "./GladlyWidget.vue?vue&type=script&lang=js"
export * from "./GladlyWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21779174",
  null
  
)

export default component.exports